import * as React from 'react';
import { FieldsProps, formValueSelector } from 'redux-form';
import { Row, Col, Button } from 'react-bootstrap';
import { ITraveller } from '../../../../../../data/api/models';
import { MedicalScreening } from 'antidote-medical-screening';
import { finishScreeningCega, startScreeningCega } from '../../../../../../data/api/api';
import { flow } from 'lodash';
import { connect } from 'react-redux';

interface ITravellersMedicalProps {
  fields: FieldsProps<any>;
  change(field: string, value: any): void;
  setIsScreening(isScreening: boolean): void;
  travellers: ITraveller[];
}

interface ITravellersMedicalState {
  key: string | number;
  loading: boolean;
  sessionId: string;
  traveller: ITraveller;
  isScreening: boolean;
  url: string;
}

class TravellersMedical extends React.Component<ITravellersMedicalProps, ITravellersMedicalState> {
  public state = {
    key: null,
    loading: false,
    sessionId: null,
    traveller: null,
    isScreening: false,
  };

  private handleStartScreening = (traveller: ITraveller, key) => () => {
    this.setState({
      loading: true,
      traveller,
      key,
    });

    const hasConditions = traveller.screening && traveller.screening.meta.conditions.length > 0;

    startScreeningCega(hasConditions ? traveller.screeningSessionId : null)
      .then(({id: sessionId, url}) => {
        this.props.setIsScreening(true);
        this.setState({
          loading: false,
          isScreening: true,
          sessionId,
          url,
        });
      });
  }

  private handleFinishScreening = () => {
    const { change } = this.props;
    const { sessionId, key } = this.state;

    finishScreeningCega(sessionId)
      .then((data) => {
        const hasConditions = data.meta.conditions.length > 0;

        change(`travellers[${key}].screeningSessionId`, hasConditions ? sessionId : null);
        change(`travellers[${key}].screening`, hasConditions ? data : null);

        this.props.setIsScreening(false);
        this.setState({
          key: null,
          traveller: null,
          sessionId: null,
          isScreening: false,
        });
      })
      .catch(() => {
        this.props.setIsScreening(false);
        this.setState({
          key: null,
          traveller: null,
          sessionId: null,
          isScreening: false,
        });
      });
  }

  private renderConditions = (conditions: string[]) => {
    if (conditions.length === 0) {
      return (
        <p className="screened-conditions">No Conditions Screened</p>
      );
    }

    return conditions.map((condition, key) => <li key={key}>{condition}</li>);
  }

  private renderTravellers = (travellerName, key) => {
    const { travellers } = this.props;
    const traveller: ITraveller = travellers[key];
    const hasConditions = !!traveller.screeningSessionId;

    return (
      <div key={key} className="traveller-medical">
        <Row>
          <Col sm={8}>
            <strong>{traveller.firstName} {traveller.lastName}</strong>
            {this.renderConditions(hasConditions ? traveller.screening.meta.conditions : [])}
          </Col>
          <Col sm={4} className="text-right">
            <Button
              bsStyle="primary"
              onClick={this.handleStartScreening(traveller, key)}
              disabled={this.state.loading}
            >
              {hasConditions ? 'Edit' : 'Add'} Conditions
            </Button>
          </Col>
        </Row>
      </div>
    );
  }

  private renderScreening = () => {
    return (
      <div className="traveller-medical">
        <MedicalScreening
          isModal={false}
          url={this.state.url}
          sessionId={this.state.sessionId}
          out={false}
          onFinish={this.handleFinishScreening}
        />

        <div className="clearfix" />
      </div>
    );
  }

  public render() {
    const { fields } = this.props;
    const { isScreening } = this.state;

    return (
      <div>
        {!isScreening && fields.map(this.renderTravellers)}
        {isScreening && this.renderScreening()}
      </div>
    );
  }
}

let selector;

export default flow([
  (component) => {
    selector = formValueSelector('quote');

    return component;
  },
  connect(
    (state) => {
      const travellers = selector(state, 'travellers');

      return {
        travellers,
      };
    },
  ),
])(TravellersMedical);
